import React from 'react';

// Serves the right responsive version via <picture>; falls back to the original image.
export default function ResponsiveImage({ src, responsive, alt = '', className, style, applyFocus = false, imgProps = {} }) {
  const focusStyle = applyFocus && responsive && (responsive.focus_x != null || responsive.focus_y != null)
    ? { objectPosition: `${responsive.focus_x ?? 50}% ${responsive.focus_y ?? 50}%` }
    : null;

  if (!responsive?.desktop?.url || responsive.applied !== true) {
    return <img src={src} alt={alt} className={className} style={style} {...imgProps} />;
  }

  const mobileSrc = responsive.mobile_override || responsive.mobile?.url;
  const intrinsicProps = {
    width: imgProps.width || responsive.desktop.width,
    height: imgProps.height || responsive.desktop.height
  };
  return (
    <picture>
      {mobileSrc && <source media="(max-width: 767px)" srcSet={mobileSrc} type={mobileSrc.includes('.webp') ? 'image/webp' : undefined} />}
      {responsive.tablet?.url && <source media="(max-width: 1279px)" srcSet={responsive.tablet.url} type={responsive.tablet.url.includes('.webp') ? 'image/webp' : undefined} />}
      <img src={responsive.desktop.url} alt={alt} className={className} style={{ ...style, ...focusStyle }} {...intrinsicProps} {...imgProps} />
    </picture>
  );
}